<template>
<div>
    <b-row class="mb-3">
        <b-col cols="6">
          <SelectList 
             :options="statusOptions"
             :value="statusFilter"
             @select="selectStatus"  
             :searchable="false" 
             :clearable="false" 
             :disabled="loading"  
           /> 

        </b-col>
        <b-col cols="6" class="text-right">
            <t-button type="add-icon" @click="toggleAddMode" :disabled="loading" :title="$t('button.add')"></t-button> 
            <t-button type="rm-icon" @click="toggleRemoveMode" :disabled="loading" :title="$t('button.remove')"></t-button> 
        </b-col>
    </b-row>

    <SelectList 
        v-if="showAddMode"
        :options="infoOptions"  
        @select="addInfo" 
        :clearable="false" 
        :disabled="loading"
        :value="selection" 
        :selectable="(option) => selectable(option)"
    /> 

    <hr>
    <!-- <label>{{ $t('timetables.attached_stops') }}</label> -->
    <b-row v-for="info in filteredInfoList" :key="info.tunnus" class='li'>
        <b-col class='info-details'>
            <div class='h'>{{ info.otsikko }}</div>
            <div><InfoTypeIcon :info="info" scale="1.3" :showText="true" /></div>    
            
            <div>
                <b-icon v-if="info.externalId" icon="link" variant="warning" scale="1.3"/>
                <b-icon v-else icon="person-fill" variant="dark" scale="1.3" />
                {{ getCreatedTooltip(info) }} 
            </div>
            

            <div><InfoValidityIcon :info="info" scale="1.3" /><span class='validity'>{{ getValidityPeriod(info) }}</span></div>
            <div v-if="!info.externalId && showRemoveMode" class='remove'>
                <t-button type="rm" @click="removeInfo(info)" ></t-button>
                <!--<button type="submit" class="btn-x rm" @click="removeInfo(info)" >
                    <b-icon icon="x"></b-icon>
                    <span>{{ $t('button.remove') }}</span> 
                </button>
                -->    

            </div>
        </b-col>
        <b-col class='info-preview'>
            <AnnouncementPreview :info="info" :showResolution="false"/>
        </b-col>
     
    </b-row>
    <span v-if="filteredInfoList.length == 0" class="info note">{{ $t('timetables.no_infos') }}</span>
    <RequestInfo :loader="loading"  />

    <!--
     <div v-if="filteredInfoList.length > 1 && showRemoveMode" style='text-align:right; font-size: 14px; margin-top: 20px'>
        <button type="submit" class="btn-x rm" @click="removeAll()" :disabled="loading">
            <b-icon icon="x"></b-icon><span>{{ $t('button.remove-all') }}</span> 
        </button>    
    </div>
    -->
</div>
</template>

<script>

import InfoTypeIcon from '@/components/Misc/InfoTypeIcon'
import AnnouncementPreview from '@/components/Announcements/AnnouncementPreview'
import announcements from '@/store/announcements/announcements'

export default {
    props: ['item'],
    components: { InfoTypeIcon, AnnouncementPreview },
    data(){
        return {
            loading: false,
            selection: "NA",
            infoList: [],
            filterOption: 'valid',
            showAddMode: false,
            showRemoveMode: false,
            statusOptions: [
            { id: 'all', label: this.$t('text_announcement_list.status.all'), icon: 'list' },
            { id: 'valid', label: this.$t('text_announcement_list.status.valid'), icon: 'check-circle', variant: 'success' },
            { id: 'upcoming', label: this.$t('text_announcement_list.status.upcoming'), icon: 'check-circle', variant: 'warning'  },
            { id: 'expired', label: this.$t('text_announcement_list.status.expired'), icon: 'x-circle', variant: 'secondary' }
            ],
            statusFilter: "valid"
        }
    },
    watch: {
        item(){
            this.infoList = [];
            this.selection = null;
            this.getValidInfos();
        }
    },
    beforeCreate(){
        if (!this.$store.state.announcements) {
            this.$store.registerModule("announcements" , announcements);
            this.$store.dispatch('announcements/getTextAnnouncementList')
            this.$store.dispatch('announcements/getImageAnnouncementList')
        }
    },
    created(){
        this.getValidInfos();
    },
    computed: {
        filterOptions(){
            return [
                { value: null, text: this.$t('filter.no'), icon: 'list' },
                { value: 'valid', text: this.$t('infovalidityicon.valid') },
                { value: 'upcoming', text: this.$t('infovalidityicon.upcoming') },
                { value: 'expired', text: this.$t('infovalidityicon.expired') }
            ];
        },
        infoOptions(){
            var optionList = [];

            //var current = new Set(this.infoList.map(item => item.tunnus));

            for (let item of this.$store.state.announcements.textAnnouncementList.listData) {
                //if(!current.has(item.tunnus))
                    optionList.push({ id: item.tunnus, label: item.otsikko, icon: "card-text" });
            }
          
            for (let item of this.$store.state.announcements.imgAnnouncementList.listData) {
                 //if(!current.has(item.tunnus))
                    optionList.push({ id: item.tunnus, label: item.otsikko, icon: "card-image", variant: "info", selectable: false })
            }

            optionList.sort((a, b) => a.label.localeCompare(b.label));

            optionList.unshift({ id: 'NA', label: this.$t("timetables.no_selection"), /*icon: "plus",*/ caption: this.$t("timetables.add_info") })

            return optionList;
        },
        filteredInfoList(){
            /*
            if (!this.filterOption) {
                return this.infoList;
            }
            return this.infoList.filter(info => {
                return this.getValidity(info) === this.filterOption;
            });
            */
            if (this.statusFilter == "all" ) {
                return this.infoList;
            }
            return this.infoList.filter(info => {
                return this.getValidity(info) === this.statusFilter;
            });
        }
    },
    methods: {
        selectable(option){
            var current = new Set(this.infoList.map(item => item.tunnus));
            return(!current.has(option.id));
            //return option.id != 'NA'
        },
        getValidInfos(){
            this.loading = true;
            //this.infoList = [];
            if(this.item){
            
                this.$traveller_http.get('/traveller/restui/content/timetableview/info', { params: { "id": this.item.id} })
                .then( response => {
                    this.infoList = response.data
                 })
                .catch( () => {} ) 
                .finally( () => { this.loading = false;  } ); 
            }

           
        },
        getValidity(info){
            var validity = "?";
            var now = Date.now();
            info.ajastusList.forEach( schedule => {
                var from = Date.parse(schedule.validityBegins);
                var to = Date.parse(schedule.validityEnds);
                if(from <= now && to >= now) validity = "valid";
                if(from > now && validity != "valid") validity = "upcoming";
                if(to < now && validity != "valid" && validity != "upcoming" ) validity = "expired";
            });

            return validity;
        },
        getValidityPeriod(info){
            var from = new Date(this.getValidityStart(info)).toLocaleDateString('fi-FI');
            if(from == 'Invalid Date') from = "?"

            var to = new Date(this.getValidityEnd(info)).toLocaleDateString('fi-FI'); 
            if(to == 'Invalid Date') to = "?"

            var note = info.ajastusList.length > 1 ? "*" : ""
          
            return from + " - " + to + note;
        },
        getValidityStart(info){
            var ts = 0;
            info.ajastusList.forEach( schedule => { 
                if(ts == 0 || schedule.validityBegins < ts)
                    ts = schedule.validityBegins;
            });
            return ts;
        },
        getValidityEnd(info){
            var ts = 0;
            info.ajastusList.forEach( schedule => { 
                if(ts == 0 || schedule.validityEnds > ts)
                    ts = schedule.validityEnds;
            });
            return ts;
        },
        getCreatedTooltip(info){
            var tooltip = info.tallentaja + " / " + new Date(info.tallennettu).toLocaleDateString('fi-FI');
            /*
            var aika = moment(info.tallennettu);
            if(aika.isValid()) {
                tooltip += " - " + aika.format("D.M.YYYY");
            }
            */

            return tooltip;
        },
        toggleAddMode() {
            this.showAddMode = !this.showAddMode;
            if (this.showAddMode) {
                this.showRemoveMode = false;
            }
        },
        toggleRemoveMode() {
            this.showRemoveMode = !this.showRemoveMode;
            if (this.showRemoveMode) {
                this.showAddMode = false;
            }
        },
        addInfo(infoId){

            if(infoId != 'NA'){
                this.loading = true;
                //this.$nextTick(() => {  this.selection = null; }); 

                let params = new URLSearchParams();
                params.append('id', this.item.id );
                params.append('iid', infoId );
                this.$traveller_http.post('/traveller/restui/content/timetableview/addInfo', params )
                .then( response => {
                    if(response.data.errorCode == 0){
                        this.getValidInfos();
                    }
                })
                .catch( () => {} ) 
                .finally( () => { /*this.loading = false; */ } ); 
            }

        },
        removeInfo(info){
            this.loading = true;
            this.$traveller_http.get('/traveller/restui/content/timetableview/removeInfo', { params: { "id": this.item.id, "iid": info.tunnus } })
            .then( response => {
                if(response.data.errorCode == 0){
                    this.getValidInfos();
                }
            })
            .catch( () => {} ) 
            .finally( () => { /*this.loading = false;*/ /*this.ok = true;  this.okMsg = i18n.t('alert.delete.ok'); */} ); 
        },
        removeAll(){
            this.loading = true;
            this.$traveller_http.get('/traveller/restui/content/timetableview/removeInfos', { params: { "id": this.item.id } })
            .then( response => {
                if(response.data.errorCode == 0){
                    this.getValidInfos();
                }
            })
            .catch( () => {} ) 
            .finally( () => {} );         
        },
        selectStatus(id) {
            this.statusFilter = id;
        }
    }
}
</script>


<style scoped lang="scss">


.text {
    font-weight: normal;
    /*padding: 5px 0px 5px 28px;*/
    
    padding: 8px 0px 8px 0px;

    /* text-align: center; */
}
/*
.text .InfoTypeIcon {
    margin-left:-28px;
}
*/

.title {
    /*
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    */
}

.validity {
    font-weight: normal;
    font-size: 13px;
    /*
    float: right;
    margin-left: auto;
    */
}

.info-header {
    display: flex;
    align-items: center;
    /* background: #f5f5f5; */
    margin-top: 8px;
}

.img-fluid {
    max-height: 100px !important;
}

.li { 
    border-bottom: none;
}

.info-details {
    border: 2px solid #ccc;
    border-right-width: 1px;
    
    padding: 5px 10px;
    
    font-weight: normal;

    .h {
        font-weight: bold;
        background: #f5f5f5; 
    }

    & > div {
        padding: 3px 3px;
        border-bottom: 1px solid #ccc;
    }

    .remove {
        margin-top: 20px;
        border-bottom: none;
        /*text-align: right;*/
    }

}


.info-preview {
    padding: 5px 10px;
    border: 2px solid #ccc;
    border-left-width: 1px;
    font-weight: normal;
   /* font-style: italic; */
   
    /*
    background: #000; 
    color: #fff; 
    */
}

.btn-x svg {
    margin-right: 0;
}

.order {
        width: 20px;
        border-radius: 50%;
        color: #fff;
        text-align: center;
   
        font-size: 12px;
        background: #007AC9;

        width: 25px;
        height: 25px;
        padding-top: 4px;

    }

</style>